//

// vendor modules
import { connect } from "react-redux"

// components
import Inline from "shared/search/components/Inline/index"

// shared modules
import { selectFormattedInlineData } from "shared/search/selectors"
import {
    selectIsBulkActionsSubmittable,
    selectIsInlineBulkActionsSelected,
} from "shared/search/searchify/bulkactions/selectors"
import {
    selectIsSearchifySubmittable,
    selectIsInlineSearchifySelected,
    selectIsFilterOnlySearchify,
} from "shared/search/searchify/selectors"
import { toggleBulkActionInlineSelectedStatus } from "shared/search/searchify/bulkactions/action-creators"
import { toggleSearchifyInlineSelectedStatus } from "shared/search/searchify/action-creators"

import { requireConfirmation } from "shared/campaign/campaign-selectors"

// Webapp only!!!! Will be undefined in mobile.
import { segueToProfile, segueToUrl } from "app/static/frontend/global-action-creators"

const mapStateToProps = (state, props) => ({
    isBulkActions: selectIsBulkActionsSubmittable(state, props),
    isSearchify: selectIsSearchifySubmittable(state, props),
    isHighlightable: selectIsSearchifySubmittable(state, props) || selectIsBulkActionsSubmittable(state, props),
    isInlineSearchifySelected: selectIsInlineSearchifySelected(state, props),
    isInlineBulkActionsSelected: selectIsInlineBulkActionsSelected(state, props),
    isInlineSelected: selectIsInlineSearchifySelected(state, props) || selectIsInlineBulkActionsSelected(state, props),
    formattedInlineArgs: selectFormattedInlineData(state, props),
    campaignRequiresConfirmation: requireConfirmation(state),
    isFilterOnlySearchify: selectIsFilterOnlySearchify(state, props),
})

export default connect(mapStateToProps, {
    toggleBulkActionInlineSelectedStatus,
    toggleSearchifyInlineSelectedStatus,
    segueToProfile,
    segueToUrl,
})(Inline)
